export default "__VITE_ASSET__Dv4LluhG__"